import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, InputNumber, Switch, Select, Button, message } from 'antd';
import { makePutCall } from '../../utils/helper';

const EditPricing = ({ visible, pricing, centres, modalities, bodyParts, onCancel, onSuccess }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (pricing) {
      form.setFieldsValue({
        cp_centre_code: pricing.cp_centre_code,
        cp_modality: pricing.cp_modality,
        cp_body_part: pricing.cp_body_part,
        cp_price: parseFloat(pricing.cp_price),
        cp_active: pricing.cp_active,
      });
    }
  }, [pricing, form]);

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const response = await makePutCall(`/centre-pricing/${pricing.cp_id}`, {
        ...values,
      });

      if (response.data.success) {
        message.success('Pricing rule updated successfully');
        form.resetFields();
        onSuccess();
      } else {
        throw new Error(response.data.message || 'Failed to update pricing rule');
      }
    } catch (error) {
      message.error(error.message || 'Failed to update pricing rule');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      title="Edit Pricing Rule"
      open={visible}
      onCancel={handleCancel}
      footer={null}
      width={600}
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        className="admin-form"
      >
        <Form.Item
          label="Centre"
          name="cp_centre_code"
          rules={[{ required: true, message: 'Please select a centre' }]}
        >
          <Select placeholder="Select centre">
            {centres.map((c) => (
              <Select.Option key={c.code} value={c.code}>
                {c.name} ({c.code})
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label="Modality"
          name="cp_modality"
          rules={[{ required: true, message: 'Please select a modality' }]}
        >
          <Select placeholder="Select modality">
            {modalities.map((m) => (
              <Select.Option key={m.value} value={m.value}>
                {m.label}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label="Body Part"
          name="cp_body_part"
          rules={[{ required: true, message: 'Please select a body part' }]}
        >
          <Select placeholder="Select body part">
            {Array.from(new Map(bodyParts.map((bp: any) => [bp.value, bp])).values()).map((bp: any) => (
              <Select.Option key={bp.value} value={bp.value}>
                {bp.label}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label="Price"
          name="cp_price"
          rules={[{ required: true, message: 'Please enter a price' }]}
        >
          <InputNumber
            min={0}
            step={0.01}
            precision={2}
            style={{ width: '100%' }}
            placeholder="Enter price"
          />
        </Form.Item>

        <Form.Item
          label="Active"
          name="cp_active"
          valuePropName="checked"
        >
          <Switch checkedChildren="Active" unCheckedChildren="Inactive" />
        </Form.Item>

        <Form.Item className="form-actions">
          <Button onClick={handleCancel} style={{ marginRight: 8 }}>
            Cancel
          </Button>
          <Button type="primary" htmlType="submit" loading={loading}>
            Update Pricing Rule
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditPricing;
